<template>
    <div class="modal fade" id="setObjectOwnersModal" ref="setObjectOwnersModal" tabindex="-1" aria-labelledby="Сохранить" aria-hidden="true">
      <div  class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div  class="modal-content p-3">
          <div class="modal-header d-flex mb-20 border-0 p-1">
            <button type="button" class="d-flex ms-auto btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div  class="modal-body d-flex flex-column p-1">

            <SelectBox
                inputId="object_owner"
                inputLabel="Собственники:"
                inputName="object_owner"
                ref="object_owner"
                inputClass="rounded-1 p-2"
                inputWrapClass="flex-column mb-4"
                inputMultiple="true"
                :inputOptions="clients_list_modal"
                :inputValue="object_owners"
                inputSearch="true"
                :inputRequired="is_owner_required"
                @setValue="updateOwners"
            />

            <div class="mt-1" v-if="selectedOwners.length > 0">
              <table class="table add_object_owners_selected_clients_list">
                <thead>
                <tr>
                  <th style="font-size: 12px">Основной контакт</th>
                  <th style="font-size: 12px">Роль в объекте</th>
                  <th style="font-size: 12px">Клиент</th>
                  <th style="font-size: 12px">Другие объекты</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="selectedOwner in selectedOwners" :key="selectedOwner.value">
                  <td style="font-size: 12px; text-align: center">
                    <label class="main-contact-radio-label">
                      <input type="radio" class="main-contact-radio" name="main_contact" :value="selectedOwner.value" v-model="mainContact" @change="setMainContact(selectedOwner.value)" />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td style="font-size: 12px">
                    <select class="role_client_in_object" v-model="selectedOwner.role" @change="updateRole(selectedOwner)">
                      <option v-for="ownerRole in ownerRoles" :key="ownerRole" :value="ownerRole">{{ ownerRole }}</option>
                    </select>
                  </td>
                  <td style="font-size: 12px">{{ selectedOwner.fio }}</td>
                  <td style="font-size: 12px">
                    <a v-if="selectedOwner.other_objects && selectedOwner.other_objects.length > 0" @click="openModalClientOtherObjects(selectedOwner.value)" href="" data-bs-toggle="modal" data-bs-target="#clientOtherObjectsModal">смотреть</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer border-0 p-1">
            <button type="button"
                    class="btn btn-primary col-12 rounded-3 py-3 text-white fs-3"
                    @click="saveObjectOwners()" >
              Сохранить
            </button>
          </div>

        </div>
      </div>
    </div>

  <ClientOtherObjectsModal :selectedOwnerId="selectedOwnerId" :objectId="objectId" />


</template>

<script>
import * as bootstrap from 'bootstrap';
import api from "@/api";
import CommonService from "@/services/CommonService";
import SelectBox from "@/components/inputs/SelectBox";
import ClientOtherObjectsModal from "@/components/modals/ClientOtherObjectsModal.vue";


export default {
  name: 'setObjectOwnersModal',
  components: {ClientOtherObjectsModal, SelectBox},
  props: {
    objectId: { type: Number },
    is_owner_required: Boolean,
    mainContactProps: { type: Number },
    operationTypeProps: { type: Number }
  },
  data() {
    return {
      ownerRoles: ['Арендодатель', 'Представитель', 'Агент', 'Застройщик'],
      object_owners: [],
      clients_list_modal: [],
      selectedOwners: [],
      search_query: '',
      clients_offset: 0,
      mainContact: null,
      selectedOwnerId: null,
      operation_type: 0
    }
  },

  methods: {
    updateRole(selectedOwner) {
      if (!selectedOwner.role) {
        selectedOwner.role = 'Арендодатель';
      }
    },
    isEmpty(data) {
      return CommonService.isEmpty(data);
    },
    updateOwners(value) {
      this.object_owners = value;
      this.ownerInfo(value);
      this.setAndValidate('object_owner', value);
    },

    openModalClientOtherObjects(selectedOwnerId) {
      console.log('selectedOwnerId: ', selectedOwnerId);
      this.selectedOwnerId = selectedOwnerId;
    },

    getOwners() {
      api.post('/object/owners', {
        object_id: this.objectId
      }).then((response) => {
        CommonService.log('debug', 'getOwners()::axios', {response: response.data});

        if (response.status == 200 && response.data.success) {
          this.object_owners = response.data.owners.map(owner => Number(owner.client_id));
          this.updateOwners(this.object_owners);
        }

        return {};
      }).catch(function (error) {
        CommonService.log('error', 'getOwners()::axios', error);
      });
    },

    ownerInfo(ownersIds) {
      api.post('/object/ownersInfo', {
        object_id: this.objectId,
        owners_ids: ownersIds,
      }).then((response) => {
        CommonService.log('debug', 'ownerInfo()::axios', {response: response.data});

        if (response.status == 200 && response.data.success) {
          this.updateSelectedOwners(response.data.owners);
          //return;
        }
        return {};
      }).catch(function (error) {
        CommonService.log('error', 'ownerInfo()::axios', error);
      });
    },

    setMainContact(id) {
      this.mainContact = id;
      },
    inArray(needle, haystack) {
      return CommonService.inArray(needle, haystack);
    },
    async getClientsListModal(clients_ids) {
      //api.get('/common/clients', {}).then((response) => {
      api.get('/object/ownersListOptions', {}).then((response) => {
        CommonService.log('debug', 'getClientsListModal()::axios', {response: response.data});

        if (response.status == 200 && response.data.success) {
          Object.entries(response.data.list).forEach(([key, option]) => {
            if (option.name || option.fio_eng) {
              let client_name = option.id;
              if (option.name && option.fio_eng) {
                client_name += ` - ${option.name} (${option.fio_eng})`;
              } else if (option.name && option.name !== '') {
                client_name += ` - ${option.name}`;
              } else if (option.fio_eng && option.fio_eng !== '') {
                client_name += ` - ${option.fio_eng}`;
              }

              this.clients_list_modal.push({
                value: option.id,
                name: client_name,
                fio: option.name || option.fio_eng,
              });
            }
          });

          return;
        }

        return {};
      }).catch(function (error) {
        CommonService.log('error', 'getClientsListModal()::axios', error);
      });
    },

    // getObjectOwners: function(){
    //   return api.post('/object/getObjectOwners')
    //       .then((response) => {
    //         CommonService.log('debug', 'getObjectOwners()::axios', {response: response.data});
    //
    //         if (response.status == 200 && response.data.success) {
    //
    //           Object.entries(response.data.list).forEach(([key, option]) => {
    //             if (option.name || option.fio_eng) {
    //               let client_name = option.id;
    //               if (option.name && option.name !== '') {
    //                 client_name += ' - ' + option.name;
    //               } else if (option.fio_eng && option.fio_eng !== '') {
    //                 client_name += ' - ' + option.fio_eng;
    //               }
    //
    //               this.clients_list_modal.push({
    //                 value: option.id,
    //                 name: client_name,
    //                 fio: option.name || option.fio_eng,
    //               });
    //             }
    //           });
    //
    //         } else {
    //           return {};
    //         }
    //
    //       }).catch(function (error) {
    //         CommonService.log('error', 'getObjectOwners()::axios', error);
    //       });
    // },

    async updateSelectedOwners(ownersData) {
      console.log('ownersData: ', ownersData);
      console.log('clients_list_modal: ', this.clients_list_modal);
      if (!Array.isArray(ownersData)) {
        ownersData = [];
      }
      if (this.clients_list_modal.length > 0) {
        this.selectedOwners = this.clients_list_modal.filter(client => this.object_owners.includes(client.value)).map(client => {
          const ownerData = ownersData.find(owner => owner.owner_id === client.value);
          if (ownerData) {
            if (ownerData.role_client_in_req) {
              client.role = ownerData.role_client_in_req;
            }
            client.other_objects = ownerData.other_objects;
          } else {
            console.warn(`Owner data not found for client value: ${client.value}`);
          }
          return client;
        });
      }
    },

    setAndValidate(name, value) {

      let errors = [];
      let parent = null;
      let child = null;
      let parts = name.split('.', 2);
      if (parts.length == 2) {
        parent = parts[0];
        child = parts[1];
      }

      // Валидация значения
      if (this.$refs[name] && typeof this.$refs[name] !== "undefined") {
        /*if ('invalid' in this.$refs[name])
            this.$refs[name].invalid = false;*/

        if (this.$refs[name].inputLabel) {
          let label = this.$refs[name].inputLabel.replace(/:+$/, '');

          let is_skip = false;
          /*if (name == 'funnel_id' && value == 0)
          is_skip = true;*/

          if (this.$refs[name].required && !is_skip) {
            if (value) {
              if (this.$refs[name].required && value.toString() == '0')
                errors.push('Поле `' + label + '` обязательно к заполнению!');
              else if (this.$refs[name].required && this.isEmpty(value))
                errors.push('Поле `' + label + '` обязательно к заполнению!');
            } else {
              errors.push('Поле `' + label + '` обязательно к заполнению!');
            }

            if (!this.isEmpty(errors)) {

              this.errors[name] = {
                name: name,
                label: label,
                errors: errors
              };

              this.$refs[name].valid = false;
              this.$refs[name].invalid = errors.join('<br/>');
            } else {
              this.$refs[name].valid = true;
              this.$refs[name].invalid = false;
            }
          }
        }
      }

      // if (name == 'object_owner') {
      //   this.updateSelectedOwners();
      // }

    },

    // saveObjectOwners: function (){
    //
    //   let ownersData = this.selectedOwners.map(owner => ({id: owner.value, role: owner.role}));
    //   let data = {
    //     owners: ownersData,
    //     object_id: this.objectId,
    //     main_contact: this.mainContact,
    //   }
    //
    //   if (!this.isEmpty(data.owners) && !this.isEmpty(data.object_id)) {
    //     api.post('/object/saveObjectOwners', data).then((response) => {
    //       CommonService.log('debug', 'saveObjectOwners()::axios', {response});
    //       if (response.status == 200 && response.data.success) {
    //         //_this.$emit('updateObject', _this.object_id);
    //
    //         let modal = CommonService.getModal('setObjectOwnersModal');
    //         if (modal)
    //           modal.hide();
    //
    //       }
    //     }).catch(function (error) {
    //       CommonService.log('error', 'saveObjectOwners()::axios', error);
    //     });
    //   }
    // },

    saveObjectOwners() {
      let ownersData = this.selectedOwners.map(owner => ({ id: owner.value, role: owner.role }));

      const hasOwners = !this.isEmpty(ownersData);
      const hasMainContact = !this.isEmpty(this.mainContact);
      const allRolesFilled = ownersData.every(owner => !this.isEmpty(owner.role));

      if (!hasOwners) {
        alert('Добавьте хотя бы одного собственника');
        return;
      }

      if (!hasMainContact) {
        alert('Выберите основной контакт');
        return;
      }

      let payload = {
        owners: ownersData,
        object_id: this.objectId,
        main_contact: this.mainContact,
      }

      if (this.objectId) {
        api.post('/object/saveObjectOwners', payload)
            .then((response) => {
              if (response.status === 200 && response.data.success) {
                CommonService.log('debug', 'saveObjectOwners()::axios', { response });
                const modal = CommonService.getModal('setObjectOwnersModal');
                if (modal) modal.hide();
              } else {
                alert('Ошибка при сохранении собственников');
              }
            })
            .catch((error) => {
              CommonService.log('error', 'saveObjectOwners()::axios', error);
              alert('Ошибка при сохранении собственников');
            });
      } else {
        this.$emit('setObjectOwners', payload);
        const modal = CommonService.getModal('setObjectOwnersModal');
        if (modal) modal.hide();
      }

      //const isOwnersListValid = !this.isEmpty(data.owners);
      //const isMainContactValid = !this.isEmpty(data.main_contact);

      // if (!isOwnersListValid) {
      //   data.owners = [];
      //   data.main_contact = "";
      //
      //   // Отправка данных на сервер
      //   api.post('/object/saveObjectOwners', data).then((response) => {
      //     CommonService.log('debug', 'saveObjectOwners()::axios', { response });
      //     if (response.status === 200 && response.data.success) {
      //       console.log('Event emitted with empty owners list');
      //       let modal = CommonService.getModal('setObjectOwnersModal');
      //       if (modal) modal.hide();
      //     } else {
      //       alert('Ошибка при сохранении данных');
      //     }
      //   }).catch((error) => {
      //     CommonService.log('error', 'saveObjectOwners()::axios', error);
      //     alert('Ошибка при сохранении данных');
      //   });
      //
      // } else {
      //   // Проверка наличия role у всех клиентов
      //   const rolesValid = ownersData.every(owner => !this.isEmpty(owner.role));
      //
      //   if (!isMainContactValid) {
      //     alert('Не выбран основной контакт');
      //     return;
      //   }
      //
      //   if (!rolesValid) {
      //     alert('Не заполнены роли клиентов');
      //     return;
      //   }
      //
      //   // Отправка данных на сервер
      //   api.post('/object/saveObjectOwners', data).then((response) => {
      //     CommonService.log('debug', 'saveObjectOwners()::axios', { response });
      //     if (response.status === 200 && response.data.success) {
      //       console.log('Event emitted with owners:', data.owners.map(owner => owner.id));
      //       let modal = CommonService.getModal('setObjectOwnersModal');
      //       if (modal) modal.hide();
      //     } else {
      //       alert('Ошибка при сохранении данных');
      //     }
      //   }).catch((error) => {
      //     CommonService.log('error', 'saveObjectOwners()::axios', error);
      //     alert('Ошибка при сохранении данных');
      //   });
      // }
    },

      icon(path, class_name, title, size) {
      return CommonService.buildIconImage(path, class_name, title, size);
    },
  },
  watch: {
    objectId: {
      immediate: true, handler(newObjectId) {
        if (newObjectId) {
          this.getOwners();
          this.updateSelectedOwners();
        }
      }
    },
    mainContactProps: {
      immediate: true, handler(newMainContactProps) {
        if (newMainContactProps) {
          this.mainContact = newMainContactProps;
        }
      }
    },
  },
  mounted() {
    let modal = this.$refs.setObjectOwnersModal;
    this.getClientsListModal();

    if (modal && typeof modal !== "undefined") {
      let _this = this;
      modal.addEventListener('hidden.bs.modal', function (event) {
        _this.section = null;
        _this.contract_id = null;
        _this.source_id = null;
        _this.item = {};
        _this.emitter.emit("global.modalClose", modal);
        _this.$emit('modalClosed');
        //_this.resetData();
      });
      modal.addEventListener('shown.bs.modal', function (event) {

        let button = event.relatedTarget
        this.object_id = button.getAttribute('data-bs-object-id');
        _this.operation_type = button.getAttribute('data-bs-operation_type');
        console.log(_this.operation_type);
        if(_this.operation_type == 1){
          _this.ownerRoles = ['Арендодатель', 'Представитель', 'Агент', 'Застройщик'];
        } else {
          _this.ownerRoles = ['Продавец', 'Представитель', 'Агент', 'Застройщик']
        }

        if (process.env.NODE_ENV == "development") {
          console.debug('addEditContractModal::show.bs.modal', {
            object_id: _this.object_id,
          });
        }
        _this.emitter.emit("global.modalShown", modal);
        _this.$emit('modalShowed');
      });
    }

  },
  computed: {
  },
}
</script>

<style>
.add_object_owners_selected_clients_list {
  .main-contact-radio-label {
    position: relative;
    cursor: pointer;
    font-size: 16px;
    user-select: none;
  }

  .main-contact-radio-label input {
    opacity: 0;
    cursor: pointer;
  }

  .main-contact-radio-label .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    border-radius: 4px;
  }

  .main-contact-radio-label input:checked ~ .checkmark {
    background-color: #4CAF50;
  }

  .main-contact-radio-label .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .main-contact-radio-label input:checked ~ .checkmark:after {
    display: block;
  }

  .main-contact-radio-label .checkmark:after {
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
  a {
    border-bottom: 1px dashed rgb(183, 188, 190)!important;
  }
  a:hover {
    color: rgb(67, 160, 71) !important;
  }
  th {
    background-color: #f2f2f2;
    text-align: left;
    border: 1px solid #ddd;
    padding: 8px;
  }
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }
}
</style>
